export default __webpack_public_path__ + "static/media/toss.e2da0679.webp";